/* ============================================================
   카운트 라이브 조회 — Supabase REST 직접 fetch
   Phase 1 시점은 GRANT 미부여 상태로 데이터 0건 빈 셸
   Phase 2 GRANT 부여 후 자동으로 카운트 표시

   [2026-05-06 정합 정정]
   DB 실측: v_dashboard_meta_full 컬럼 object_kind (object_type 아님)
   row_count 컬럼 없음 — Phase 2 동적 카운트 도입 별도 트랙
   ============================================================ */
import { useEffect, useState } from 'react'
import { supabase, SUPABASE_AVAILABLE } from './supabase'

export interface SchemaStats {
  schemas: number
  tables: number
  views: number
  rows: number
  ready: boolean
  error?: string
}

const INITIAL: SchemaStats = { schemas: 0, tables: 0, views: 0, rows: 0, ready: false }

export function useStats(): SchemaStats {
  const [stats, setStats] = useState<SchemaStats>(INITIAL)

  useEffect(() => {
    if (!SUPABASE_AVAILABLE || !supabase) {
      setStats({ ...INITIAL, ready: true, error: 'env_missing' })
      return
    }

    let cancelled = false
    ;(async () => {
      try {
        // v_dashboard_meta_full 활용 — Rule #70 정합 (mg_security 자동 차단)
        const { data, error } = await supabase
          .schema('mg_system')
          .from('v_dashboard_meta_full')
          .select('schema_name, object_kind')

        if (cancelled) return
        if (error) {
          setStats({ ...INITIAL, ready: true, error: error.message })
          return
        }

        const rows = data ?? []
        const uniqueSchemas = new Set(rows.map(r => r.schema_name)).size
        const tables = rows.filter(r => r.object_kind === 'table').length
        const views = rows.filter(r => r.object_kind === 'view').length
        // TOTAL ROWS — Phase 2 동적 카운트 도입 예정 (현재는 0 표시)
        const totalRows = 0

        setStats({
          schemas: uniqueSchemas,
          tables,
          views,
          rows: totalRows,
          ready: true,
        })
      } catch (e) {
        if (!cancelled) {
          setStats({ ...INITIAL, ready: true, error: String(e) })
        }
      }
    })()

    return () => { cancelled = true }
  }, [])

  return stats
}
